import { Eligibility } from './eligibility.types'

/**
 * Patterns indicating the GM eligibility API is down.
 * ERS gateway returns HTTP 200 with body containing eligibilityFailureReason when GM API fails (e.g. 500).
 * Real API may use "GM API: Failed to call GM API" or "GM: API: failed to call GM API".
 * Other OEMs (Honda, Hyundai, etc.) may use different patterns; extend if/when known.
 */
const ELIGIBILITY_API_DOWN_PATTERNS = [
  'GM: API: failed to call GM API',
  'GM API: Failed to call GM API',
]

/**
 * Determines if the eligibility failure is due to the eligibility service being down,
 * based on contractIdentityData.additionalInformation eligibilityFailureReason.
 * Currently supports GM/GMC OEM pattern.
 */
export const isEligibilityServiceDown = (eligibility: Eligibility): boolean => {
  const additionalInfo =
    (eligibility.contractIdentityData as { additionalInformation?: Array<{ key?: string; value?: string }> })
      ?.additionalInformation ?? []

  return additionalInfo.some(
    (item) =>
      item.key === 'eligibilityFailureReason' &&
      typeof item.value === 'string' &&
      ELIGIBILITY_API_DOWN_PATTERNS.some((pattern) => item.value!.startsWith(pattern))
  )
}
